import React, { useContext, useEffect, useState } from 'react';
import { Place } from '../../app/models/Place';
import { ServiceEventsDocuments, ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';
import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { AppContext } from '../../contexts/AppContext';

import moment from 'moment';
import { useHistory } from 'react-router-dom';

import InternalSettlementDataTable from './components/tables/InternalSettlementDataTable';
import useNavigationPage from '../../hooks/useNavigationPage';
import useInternalSettlementService from '../../app/services/hooks/useInternalSettlementService';
import { InternalSettlement, InternalSettlementFilters } from '../../app/models/InternalSettlement';
import { BusinessName } from '../../app/models/BusinessName';
import { BusinessEntity } from '../../app/models/BusinessEntity';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Liquidación interna',
        url: '/internal-settlements',
        isActive: true
    }
];

const InternalSettlements = () => {
    const history = useHistory();

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const {
        fetchingGetInternalSettlements,
        fetchingGetExcelInternalSettlements,
        getExcelAllInternalSettlements,
        getInternalSettlements,
        getDataToFilter,
        fetchingGetDataToFilter
    } = useInternalSettlementService();

    const [internalSettlements, setInternalSettlements] = useState<InternalSettlement[]>([]);
   
    const [totalRows, setTotalRows] = useState<number>(0);
    const [allCredit, setAllCredit] = useState<number>(0);
    const [allDebit, setAllDebit] = useState<number>(0);
    const { navigationPage } = useNavigationPage();

    const [InternalSettlementFilter, setInternalSettlementFilter] =
        useState<InternalSettlementFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            issue_date_from: moment().date(1).format('YYYY-MM-DD'),
            issue_date_until: moment().format('YYYY-MM-DD')
        });

    const [businessNames, setBusinessNames] = useState<BusinessName[]>([]);
    const [businessNamesCompare, setBusinessNamesCompare] = useState<BusinessName[]>([]);
    const [businessEntitiesCompare, setBusinessEntitiesCompare] = useState<BusinessEntity[]>([]);
    
    useEffect(() => {
        reloadTable();
    }, [InternalSettlementFilter]);

    useEffect(() => {
        getDataFilter()
    }, [InternalSettlementFilter.business_name_id]);

    const getAllInternalSettlement = () => {
        getInternalSettlements(InternalSettlementFilter, {
            onSuccess: (response: ServiceResponse) => {
                setInternalSettlements(response.data.internal_settlements);
                setTotalRows(response.data.total_rows);
                setAllCredit(response.data.all_credit);
                setAllDebit(response.data.all_debit);
                
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        });
    };

    const getDataFilter = () => {
        
        getDataToFilter(Number(InternalSettlementFilter.business_name_id), {

            onSuccess: (response: ServiceResponse) => {

                setBusinessNames(response.data.sender_business_names);
                setBusinessEntitiesCompare(response.data.business_entities);
                setBusinessNamesCompare(response.data.business_names);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        })

    }

    const reloadTable = () => {
        getAllInternalSettlement();
    };

    const downloadExcel = () => {
        if (showLoading) showLoading('download', 'Recuperando documento...');
        getExcelAllInternalSettlements(InternalSettlementFilter, {
            onSuccess: (message: string) => {
                if (changeAnimation) changeAnimation('downloadSuccess', message, true);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };


    return (
        <>
            <Breadcrumbs pageSection="Cuentas" breadcrumbs={breadcrumbs} />

            <DefaultCard>
                <InternalSettlementDataTable
                    internalSettlements={internalSettlements}
                    loading={fetchingGetInternalSettlements}
                    filter={InternalSettlementFilter}
                    setFilter={setInternalSettlementFilter}
                    totalRows={totalRows}
                    allCredit={allCredit}
                    allDebit={allDebit}
                    downloadExcel={downloadExcel}
                    businessNames={businessNames}
                    businessNamesCompare={businessNamesCompare}
                    businessEntitiesCompare={businessEntitiesCompare}
                />
            </DefaultCard>
          
        </>
    );
};

export default InternalSettlements;
